import { render, staticRenderFns } from "./DSProgressIndicator.vue?vue&type=template&id=0b65902c&"
import script from "./DSProgressIndicator.vue?vue&type=script&lang=js&"
export * from "./DSProgressIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports